$(document).ready(function () {

  //url extra parameter remove
      // function removeAllQueryParameters() {
      //     let url = window.location.href;
      //     let urlObj = new URL(url);
      //     urlObj.search = '';
      //     window.history.replaceState({}, document.title, urlObj.toString());
      // }
      // removeAllQueryParameters();
  
  // Home Page Tab Section

    $(document).on("click",".tab_title_main span a",function() {
    $(".tab_title_main span a").removeClass("active");
    $(this).addClass("active");
    $(".fe-tab-content").hide();

    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });

  // Home Page Slider
  var swiper = new Swiper(".best_price_slider", {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: ".best_swiper_dots",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
    },
  });

  // custom menu toggle

  $(document).on(
    "click",
    "#HeaderMenu-candle-making-supplies,a#HeaderDrawer-candle-making-supplies",
    function (event) {
      event.preventDefault();
      $(".custom_menu_grid").fadeIn();
    }
  );

  $(document).mouseup(function (e) {
    var container = $(".custom_menu_grid,#HeaderMenu-candle-making-supplies");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".custom_menu_grid").fadeOut();
    }
  });

  // slider link
  var sliderlinkswiper = new Swiper(".slider-link-swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".best_swiper_dots",
      clickable: true,
    },
  });
  // backtotop
  $(".back-to-top").attr("href", "#top-section");
  $(window).scroll(function () {
    var aTop = 300;
    if ($(this).scrollTop() > aTop) {
      $(".back-to-top").css("opacity", "1");
      $(".back-to-top").css("visibility", "visible");
      $(".back-to-top").css("bottom", "20px");
    }
    if ($(this).scrollTop() < aTop) {
      $(".back-to-top").css("opacity", "0");
      $(".back-to-top").css("visibility", "hidden");
      $(".back-to-top").css("bottom", "0px");
    }
  });

  var customImageSlider = new Swiper(".custom-image-slider", {
    navigation: {
      nextEl: ".swiper-button-next-image",
      prevEl: ".swiper-button-prev-image",
    },
  });

  // featured collection slider
  var customFeaturedSlider = new Swiper(".custom-featured-slider", {
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next cstm-next",
      prevEl: ".swiper-button-prev cstm-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      425: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
  // image-with-product-slider
  var imageproductswiper = new Swiper(".image-with-product-slider", {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next-image-with-product",
      prevEl: ".swiper-button-prev-image-with-product",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
  // text-with-image-slider
  var textimageswiper = new Swiper(".text-and-image-slider", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });
  var aftertextimageswiper = new Swiper(".after-text-and-image-slider", {
    slidesPerView: 1,

    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });

  //accessibility poup
  $(document).on("click", ".accessibility_support_btn", function () {
    $(".accessibility_popup").fadeIn();
  });
  $(document).on("click", ".acc_popup_off", function () {
    $(".accessibility_popup").fadeOut();
  });
  console.log($(" .absolute-text-main-grid").children().length);
  console.log($(".absolute-text-container ").children().length);
  if (
    $(" .absolute-text-main-grid").children().length < 1 &&
    $(".absolute-text-container ").children().length <= 1
  ) {
    $(".absolute-text-container ").css("display", "none");
  }
});
$(".description_tab li").click(function () {
  var d_id = $(this).attr("data-tab");

  $(".description_tab li").removeClass("active");
  $(".desc_content").removeClass("active");

  $(this).addClass("active");
  $("#" + d_id).addClass("active");
});
